import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  TextField,
  Tab,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import {
  East as EastIcon,
  Edit as EditIcon,
} from "@mui/icons-material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { styled } from "@mui/material/styles";
import { pathJoinUrl } from "@smfa/utils/src";
import { AppContext } from "../context";
import {
  getMembershipHighlightBanner,
  addEditMembershipBanner,
  getMembershipIntro,
  getMembershipMemberList,
  addEditMembershipIntro,
  addEditMembershipMember,
  getEnableMembership,
  getDisableMembership,
} from "../actions/membership.actions";
import FileUploadArea from "./common/FileUploadArea";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#65C466",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const Memberhighlight = () => {
  const [value, setValue] = React.useState("1");
  const { storage } = useContext(AppContext);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  var addAboutBanner_default = {
    membershiphligh_banner_section_id: 0,

    banner_image: "",
    banner_image_name: "",
    banner_image_error: false,
    banner_image_mob: "",
    banner_image_mob_name: "",
    banner_image_mob_error: false,
    banner_title: "",
    banner_title_maxlenth: 30,
    banner_title_error: false,
  };

  var addMembershipHighlight_default = {
    membership_section_id: 0,

    membership_section_title: "",
    membership_section_title_maxlenth: 50,
    membership_section_title_error: false,

    membership_section_des: "",
    membership_section_des_maxlenth: 380,
    membership_section_des_error: false,
  };

  const [addMembershipHighlight, setMembershipHighlight] = useState(
    addMembershipHighlight_default,
  );

  const [loaderId, setLoaderId] = useState("");
  const [addAboutBanner, setAboutBanner] = useState(addAboutBanner_default);

  const [deskimage, setDeskImage] = useState("");
  const onImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files[0]) {
      setDeskImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image = event.target.files[0];
      custInfo.banner_image_name = event.target.files[0].name;
      custInfo.banner_image_error = false;
      setAboutBanner(custInfo);
    }
  };

  const [mobimage, setMobImage] = useState("");
  const onMobImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.files && event.target.files[0]) {
      setMobImage(URL.createObjectURL(event.target.files[0]));
      custInfo.banner_image_mob = event.target.files[0];
      custInfo.banner_image_mob_name = event.target.files[0].name;
      custInfo.banner_image_mob_error = false;
      setAboutBanner(custInfo);
    }
  };

  const [memeberList, setMemeberList] = useState([]);
  const [firstLoading, setFirstLoading] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(50);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPage, setTotalPage] = useState(1);
  const [searchText, setSearchText] = useState("");

  const [searchType, setSearchType] = useState("member_title");
  const [pageLoader, setPageLoader] = useState(false);

  var addMemeber_default = {
    member_id: 0,

    member_image: "",
    member_image_name: "",
    member_image_error: false,
    member_image_mob: "",
    member_image_mob_name: "",
    member_image_mob_error: false,
    member_title: "",
    member_title_maxlenth: 40,
    member_title_error: false,
    member_des: "",
    member_des_maxlenth: 300,
    member_des_error: false,
    member_qualification: "",
    member_qualification_maxlenth: 20,

    member_qualification_error: false,
  };

  const [addMemeber, setMemeber] = useState(addMemeber_default);

  const [mobmemberimage, setMobMemberImage] = useState("");
  const onMobMemberImageChange = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMemeber };
    if (event.target.files && event.target.files[0]) {
      setMobMemberImage(URL.createObjectURL(event.target.files[0]));
      custInfo.member_image = event.target.files[0];
      custInfo.member_image_name = event.target.files[0].name;
      custInfo.member_image_error = false;
      setMemeber(custInfo);
    }
  };

  const clearBannerUpload = (field, clearPreview) => {
    clearPreview("");
    setAboutBanner((previous) => ({
      ...previous,
      [field]: "",
      [`${field}_name`]: "",
    }));
  };

  const clearMemberUpload = () => {
    setMobMemberImage("");
    setMemeber((previous) => ({
      ...previous,
      member_image: "",
      member_image_name: "",
    }));
  };

  const handleChange = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setValue(newValue);
    setMemeber(addMemeber_default);
  };
  const handleChangeedit = (event, newValue) => {
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setValue(newValue);
  };

  useEffect(() => {
    getMembershipHighlightBanner().then((res) => {
      var locInfo = { ...addAboutBanner };
      if (res.data.status === true) {
        locInfo.membershiphligh_banner_section_id =
          res.data.data.membershiphligh_banner_section_id;

        locInfo.banner_title = res.data.data.banner_title;

        locInfo.banner_image_name = res.data.data.banner_image;
        locInfo.banner_image_mob_name = res.data.data.banner_image_mob;
        setAboutBanner(locInfo);
        if (res.data.data.banner_image !== null) {
          setDeskImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image),
          );
        }
        if (res.data.data.banner_image_mob !== null) {
          setMobImage(
            pathJoinUrl(storage[0].imageEndUrl, res.data.data.banner_image_mob),
          );
        }
      } else {
      }
    });

    getMembershipIntro().then((res) => {
      var locInfo = { ...addMembershipHighlight };
      if (res.data.status === true) {
        locInfo.membership_section_id = res.data.data.membership_section_id;

        locInfo.membership_section_title =
          res.data.data.membership_section_title;
        locInfo.membership_section_des = res.data.data.membership_section_des;
        setMembershipHighlight(locInfo);
      } else {
      }
    });
    getMembershipMemberList({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const addAboutBannerInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addAboutBanner };
    if (event.target.name === "banner_title") {
      if (event.target.value.length <= addAboutBanner.banner_title_maxlenth) {
        custInfo.banner_title = event.target.value;
        custInfo.banner_title_error = false;
      }
    }

    setAboutBanner(custInfo);
  };

  const submitLocation = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addAboutBanner };

    if (addAboutBanner.banner_title === "") {
      document.getElementById("banner_title").focus();
      custInfo.banner_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setAboutBanner(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append(
      "membershiphligh_banner_section_id",
      addAboutBanner.membershiphligh_banner_section_id,
    );
    formData.append("banner_image_mob", addAboutBanner.banner_image_mob);
    formData.append("banner_image", addAboutBanner.banner_image);
    formData.append("banner_title", addAboutBanner.banner_title);

    if (addAboutBanner.membershiphligh_banner_section_id === 0) {
      addEditMembershipBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Join  Addedd Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setAboutBanner(addAboutBanner_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setAboutBanner(addAboutBanner_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addEditMembershipBanner(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Banner Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };

  const addMembershipHighlightInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMembershipHighlight };
    if (event.target.name === "membership_section_title") {
      if (
        event.target.value.length <=
        addMembershipHighlight.membership_section_title_maxlenth
      ) {
        custInfo.membership_section_title = event.target.value;
        custInfo.membership_section_title_error = false;
      }
    }

    if (event.target.name === "membership_section_des") {
      if (
        event.target.value.length <=
        addMembershipHighlight.membership_section_des_maxlenth
      ) {
        custInfo.membership_section_des = event.target.value;
        custInfo.membership_section_des_error = false;
      }
    }

    setMembershipHighlight(custInfo);
  };

  const submitLocationMembershipHighlight = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addMembershipHighlight };

    if (addMembershipHighlight.membership_section_title === "") {
      document.getElementById("membership_section_title").focus();
      custInfo.membership_section_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipHighlight(custInfo);

      setLoader(false);
      return false;
    }

    if (addMembershipHighlight.membership_section_des === "") {
      document.getElementById("membership_section_des").focus();
      custInfo.membership_section_des_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMembershipHighlight(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append(
      "membership_section_id",
      addMembershipHighlight.membership_section_id,
    );
    formData.append(
      "membership_section_title",
      addMembershipHighlight.membership_section_title,
    );
    formData.append(
      "membership_section_des",
      addMembershipHighlight.membership_section_des,
    );

    if (addMembershipHighlight.membership_section_id === 0) {
      addEditMembershipIntro(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Join Added Successfully!");
            setLoader(false);
            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setMembershipHighlight(addMembershipHighlight_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setMembershipHighlight(addMembershipHighlight_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addEditMembershipIntro(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setSuccessMsg("Highlight Updated Successfully!");
            setLoader(false);

            setTimeout(function () {
              setLoader(false);
              setSuccessMsg("");
            }, 3000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };

  const perPageChange = (e) => {
    setPerPage(e.target.value);
    setPageNo(1);

    getMembershipMemberList({
      pageNo: 1,
      perPage: e.target.value,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList(res.data.data);
      }
    });
  };

  const changePage = (page) => {
    if (page < 1) page = 1;
    if (page > totalPage) page = totalPage;
    setPageLoader(true);
    setPageNo(page);

    getMembershipMemberList({
      pageNo: page,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList(res.data.data);
      }
      setPageLoader(false);
    });
  };
  const addMemeberInfo = (event) => {
    setSuccessMsg("");
    setErrorMsg("");

    var custInfo = { ...addMemeber };
    if (event.target.name === "member_title") {
      if (event.target.value.length <= addMemeber.member_title_maxlenth) {
        custInfo.member_title = event.target.value;
        custInfo.member_title_error = false;
      }
    }
    if (event.target.name === "member_qualification") {
      if (
        event.target.value.length <= addMemeber.member_qualification_maxlenth
      ) {
        custInfo.member_qualification = event.target.value;
        custInfo.member_qualification_error = false;
      }
    }
    if (event.target.name === "member_des") {
      if (event.target.value.length <= addMemeber.member_des_maxlenth) {
        custInfo.member_des = event.target.value;
        custInfo.member_des_error = false;
      }
    }
    setMemeber(custInfo);
  };

  const submitLocationMember = () => {
    // return false;
    setLoader(true);
    setSuccessMsg("");
    setErrorMsg("");
    var custInfo = { ...addMemeber };

    if (addMemeber.member_title === "") {
      document.getElementById("member_title").focus();
      custInfo.member_title_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMemeber(custInfo);

      setLoader(false);
      return false;
    }
    if (addMemeber.member_qualification === "") {
      document.getElementById("member_qualification").focus();
      custInfo.member_qualification_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMemeber(custInfo);

      setLoader(false);
      return false;
    }
    if (addMemeber.member_des === "") {
      document.getElementById("member_des").focus();
      custInfo.member_des_error = true;
      //  setErrorMsg('Please Enter Operating Unit!');
      setMemeber(custInfo);

      setLoader(false);
      return false;
    }

    const formData = new FormData();
    formData.append("member_id", addMemeber.member_id);
    formData.append("member_image", addMemeber.member_image);
    formData.append("member_image_mob", addMemeber.member_image_mob);
    formData.append("member_title", addMemeber.member_title);
    formData.append("member_des", addMemeber.member_des);
    formData.append("member_qualification", addMemeber.member_qualification);
    if (addMemeber.member_id === 0) {
      addEditMembershipMember(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setMemeber(addMemeber_default);
            setSuccessMsg("Member  Addedd Successfully!");

            setMobImage("");
            getMembershipMemberList({
              pageNo: pageNo,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setMemeberList(res.data.data);
              } else {
                setMemeberList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "4");
            }, 1000);
          } else {
            setMemeber(addMemeber_default);
            setErrorMsg(res1.data.message);
            setLoader(false);
          }
        })
        .catch((error) => {
          setMemeber(addMemeber_default);
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    } else {
      addEditMembershipMember(formData)
        .then((res1) => {
          if (res1.data.status === true) {
            setMemeber(addMemeber_default);

            setSuccessMsg("Member Updated Successfully!");

            setMobImage("");
            getMembershipMemberList({
              pageNo: 1,
              perPage: perPage,
              searchText: searchText,
              searchType: searchType,
            }).then((res) => {
              setTotalCount(res.data.pagination.totalCount);
              setTotalPage(res.data.pagination.totalPage);
              if (res.data.data.length > 0) {
                setMemeberList(res.data.data);
              } else {
                setMemeberList([]);
              }
              setFirstLoading(false);
            });
            setLoader(false);
            setTimeout(function () {
              const startEvent = new Event("start");
              setSuccessMsg("");
              setErrorMsg("");
              handleChange(startEvent, "4");
            }, 1000);
          } else {
            setErrorMsg("Something went wrong,please try again!");
            setLoader(false);
          }
        })
        .catch((error) => {
          setLoader(false);
          setErrorMsg("Something went wrong,please try again!");
        });
    }
  };
  const editLocation = (e, val) => {
    var locInfo = { ...addMemeber };
    locInfo.member_id = val.member_id;

    locInfo.member_des = val.member_des;
    locInfo.member_qualification = val.member_qualification;
    locInfo.member_title = val.member_title;

    locInfo.member_image_name = val.member_image;
    setMemeber(locInfo);

    if (val.member_image !== null) {
      setMobMemberImage(pathJoinUrl(storage[0].imageEndUrl, val.member_image));
    }

    setSuccessMsg("");
    setErrorMsg("");
    const startEvent = new Event("start");

    handleChangeedit(startEvent, "3");
  };

  const checkfilsiw = (newValue) => {
    setErrorMsg("");
    setSearchText("");
    if (newValue === "member_title") {
      setSearchType("member_title");
      document.getElementById("member_title").style.display = "block";
      document.getElementById("member_qualification").style.display = "none";
    }

    if (newValue === "member_qualification") {
      setSearchType("member_qualification");
      document.getElementById("member_qualification").style.display = "block";
      document.getElementById("member_title").style.display = "none";
    }
  };
  const checksortall = (newValue, sort) => {
    let element;
    setErrorMsg("");
    if (newValue === "member_title") {
      if (sort === "desc") {
        element = document.getElementById("member_titleasc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("member_titledesc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
      if (sort === "asc") {
        element = document.getElementById("member_titledesc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("member_titleasc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
    }

    if (newValue === "member_qualification") {
      if (sort === "desc") {
        element = document.getElementById("member_qualificationasc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("member_qualificationdesc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
      if (sort === "asc") {
        element = document.getElementById("member_qualificationdesc");
        element.classList.remove("sortopacity");
        element.style.visibility = "inherit";
        element = document.getElementById("member_qualificationasc");
        element.classList.add("sortopacity");
        element.style.visibility = "hidden";
      }
    }

    setFirstLoading(true);
    getMembershipMemberList({
      pageNo: pageNo,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
      sort: sort,
      sortvalue: newValue,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
  };
  const doSearch = (e) => {
    if (e.target.name === "member_qualification") {
      setSearchText(e.target.value);
    }
    if (e.target.name === "member_title") {
      setSearchText(e.target.value);
    }
  };
  const gosubmit = (e) => {
    setErrorMsg("");

    if (searchType === "member_title") {
      if (searchText === "") {
        return false;
      }
    }

    if (searchType === "member_qualification") {
      if (searchText === "") {
        return false;
      }
    }

    setFirstLoading(true);
    getMembershipMemberList({
      pageNo: 1,
      perPage: perPage,
      searchText: searchText,
      searchType: searchType,
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
  };
  const clearfilter = () => {
    setErrorMsg("");
    setSearchText("");

    setMobImage("");
    setSearchType("title");
    setFirstLoading(true);
    document.getElementById("member_qualification").style.display = "none";
    document.getElementById("member_title").style.display = "block";
    //  document.getElementById("location").style.display='none';

    setMemeberList([]);
    getMembershipMemberList({
      pageNo: 1,
      perPage: perPage,
      searchText: "",
      searchType: "member_id",
    }).then((res) => {
      setTotalCount(res.data.pagination.totalCount);
      setTotalPage(res.data.pagination.totalPage);
      if (res.data.data.length > 0) {
        setMemeberList(res.data.data);
      } else {
        setMemeberList([]);
      }
      setFirstLoading(false);
    });
  };

  const toggleOn = (val) => {
    setLoaderId(val);

    getEnableMembership({ member_id: val }).then((result) => {
      getMembershipMemberList({
        pageNo: pageNo,
        perPage: perPage,
        searchText: searchText,
        searchType: searchType,
      }).then((res) => {
        setTotalCount(res.data.pagination.totalCount);
        setTotalPage(res.data.pagination.totalPage);
        if (res.data.data.length > 0) {
          setMemeberList(res.data.data);
        } else {
          setMemeberList([]);
        }
        setLoaderId("");
      });
    });
  };

  const toggleOff = (val) => {
    setLoaderId(val);

    getDisableMembership({ member_id: val }).then((result) => {
      getMembershipMemberList({
        pageNo: pageNo,
        perPage: perPage,
        searchText: searchText,
        searchType: searchType,
      }).then((res) => {
        setTotalCount(res.data.pagination.totalCount);
        setTotalPage(res.data.pagination.totalPage);
        if (res.data.data.length > 0) {
          setMemeberList(res.data.data);
        } else {
          setMemeberList([]);
        }
        setLoaderId("");
      });
    });
  };

  const resetdoc = () => {
    setMobMemberImage("");
    setSuccessMsg("");
    setErrorMsg("");
    setLoader(false);
    setMemeber(addMemeber_default);
  };
  return (
    <>
      <div className="content">
        <div className="body-inner-sec">
          <div className="container-fluid">
            <div className="row">
              <div className="banner-inner-bdy-sec tab-sec-smfa">
                <Box sx={{ width: "100%", typography: "body1" }}>
                  <TabContext value={value}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <TabList
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                      >
                        <Tab label="Add Banner" value="1" />
                        <Tab label="Add Introduction" value="2" />
                        <Tab
                          label={` ${addMemeber.member_id !== 0 ? "Update" : "Add"} Membership`}
                          value="3"
                        />
                        <Tab label="Manage Membership" value="4" />
                      </TabList>
                    </Box>
                    <TabPanel value="1">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="about-banner-sec">
                            <div className="form-secs inner-form-secs vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="banner_title"
                                  label="Title"
                                  variant="standard"
                                  onChange={addAboutBannerInfo}
                                  name="banner_title"
                                  value={addAboutBanner.banner_title}
                                  error={addAboutBanner.banner_title_error}
                                  helperText={` ${addAboutBanner.banner_title_error === true ? "Please enter Title!" : ""}`}
                                />
                                <div className="charcter-sec">
                                  {addAboutBanner.banner_title_maxlenth -
                                    addAboutBanner.banner_title.length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addAboutBanner.banner_title_maxlenth -
                                          addAboutBanner.banner_title.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-5 banner-uplod-secs membr-banner">
                          <FileUploadArea
                            title="Add Banner Image For Desktop"
                            description={
                              <>
                                Best image Resolution: 1920px X 836px
                                <br />
                                Supported files types: JPG, JPEG & PNG
                              </>
                            }
                            previewUrl={deskimage}
                            fileName={addAboutBanner.banner_image_name}
                            onChange={onImageChange}
                            deleteRequest={{
                              resource: "membership-highlight-banner",
                              id: addAboutBanner.membershiphligh_banner_section_id,
                              field: "banner_image",
                            }}
                            onRemove={() =>
                              clearBannerUpload("banner_image", setDeskImage)
                            }
                            accept=".png,.jpg,.jpeg"
                          />
                        </div>
                        <div className="col-md-5 banner-uplod-secs membr-banner">
                          <FileUploadArea
                            title="Add Banner Image For Mobile"
                            description={
                              <>
                                Best image Resolution: 400px X 350px
                                <br />
                                Supported files types: JPG, JPEG & PNG
                              </>
                            }
                            previewUrl={mobimage}
                            fileName={addAboutBanner.banner_image_mob_name}
                            onChange={onMobImageChange}
                            deleteRequest={{
                              resource: "membership-highlight-banner",
                              id: addAboutBanner.membershiphligh_banner_section_id,
                              field: "banner_image_mob",
                            }}
                            onRemove={() =>
                              clearBannerUpload(
                                "banner_image_mob",
                                setMobImage,
                              )
                            }
                            accept=".png,.jpg,.jpeg"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="button-sec">
                            <button
                              type="button"
                              className="btn btn-login btn-update"
                              onClick={(e) => {
                                submitLocation();
                                e.preventDefault();
                              }}
                            >
                              Update
                              {loader === true ? (
                                <CircularProgress
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    marginLeft: "5px",
                                    color: "white",
                                  }}
                                />
                              ) : (
                                ""
                              )}
                            </button>
                            <div className="validate-sec">
                              {successMsg !== "" ? (
                                <div className="">
                                  <p className="succ-msg">{successMsg}</p>
                                </div>
                              ) : (
                                <div className="">
                                  <p
                                    className="succ-msg"
                                    style={{ visibility: "hidden" }}
                                  >
                                    Banner Updated Successfully!
                                  </p>
                                </div>
                              )}
                              {errorMsg !== "" ? (
                                <div className="">
                                  <p className="error-msg">{errorMsg}</p>
                                </div>
                              ) : (
                                <div className="">
                                  <p
                                    className="error-msg"
                                    style={{ visibility: "hidden" }}
                                  >
                                    Something went wrong, please try again!
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="2">
                      <div className="baner-tab-add-sec">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-secs  inner-form-secs vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& > :not(style)": { m: 1, width: "25ch" },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="membership_section_title"
                                  label="Title"
                                  variant="standard"
                                  onChange={addMembershipHighlightInfo}
                                  name="membership_section_title"
                                  value={
                                    addMembershipHighlight.membership_section_title
                                  }
                                  error={
                                    addMembershipHighlight.membership_section_title_error
                                  }
                                  helperText={` ${addMembershipHighlight.membership_section_title_error === true ? "Please enter Title!" : ""}`}
                                />
                                <div className="charcter-sec">
                                  {addMembershipHighlight.membership_section_title_maxlenth -
                                    addMembershipHighlight
                                      .membership_section_title.length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec">
                                        Max Characters:&nbsp;
                                        {addMembershipHighlight.membership_section_title_maxlenth -
                                          addMembershipHighlight
                                            .membership_section_title.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>

                          <div className="col-md-8">
                            <div className="form-secs  form-secs-textarea  inner-form-secs vali-forms">
                              <Box
                                component="form"
                                sx={{
                                  "& .MuiTextField-root": {
                                    m: 1,
                                    width: "25ch",
                                  },
                                }}
                                noValidate
                                autoComplete="off"
                              >
                                <TextField
                                  id="membership_section_des"
                                  label="Short Description"
                                  placeholder="Short Description"
                                  multiline
                                  rows={2}
                                  variant="standard"
                                  onChange={addMembershipHighlightInfo}
                                  name="membership_section_des"
                                  value={
                                    addMembershipHighlight.membership_section_des
                                  }
                                  error={
                                    addMembershipHighlight.membership_section_des_error
                                  }
                                  helperText={` ${addMembershipHighlight.membership_section_des_error === true ? "Please enter Title!" : ""}`}
                                />
                                <div
                                  className="charcter-sec"
                                  style={{ marginTop: "7px" }}
                                >
                                  {addMembershipHighlight.membership_section_des_maxlenth -
                                    addMembershipHighlight
                                      .membership_section_des.length ===
                                  0 ? (
                                    <>
                                      <span
                                        className="char-limit"
                                        style={{ color: "#FF0000" }}
                                      >
                                        Max Character Limit reached{" "}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <p className="max-charact-sec max-para">
                                        Max Characters:&nbsp;
                                        {addMembershipHighlight.membership_section_des_maxlenth -
                                          addMembershipHighlight
                                            .membership_section_des.length}
                                      </p>
                                    </>
                                  )}
                                </div>
                              </Box>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec update-mrn"
                              style={{ marginTop: "0px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocationMembershipHighlight();
                                  e.preventDefault();
                                }}
                              >
                                Update
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Introduction added Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="3">
                      <div className="baner-tab-add-sec">
                        <div className="row">
                          <div className="col-md-6">
                            <FileUploadArea
                              title="Upload Image"
                              description={
                                <>
                                  Best image Resolution: 130px X 130px
                                  <br />
                                  Supported files types: JPG, JPEG & PNG
                                </>
                              }
                              previewUrl={mobmemberimage}
                              fileName={addMemeber.member_image_name}
                              onChange={onMobMemberImageChange}
                              deleteRequest={{
                                resource: "membership-member",
                                id: addMemeber.member_id,
                                field: "member_image",
                              }}
                              onRemove={clearMemberUpload}
                              accept=".png,.jpg,.jpeg"
                            />
                          </div>

                          <div className="col-md-6">
                            <div className="banner-uplod-secs banner-abt-sec direct-sbt-sec">
                              <div className="banner-img-secs">
                                <div className="banner-img">
                                  <h2
                                    style={{
                                      marginTop: "10px",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    Membership Details
                                  </h2>
                                </div>

                                <div
                                  className="form-secs inner-form-secs vali-forms"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="member_title"
                                      label="Name"
                                      variant="standard"
                                      onChange={addMemeberInfo}
                                      name="member_title"
                                      value={addMemeber.member_title}
                                      error={addMemeber.member_title_error}
                                      helperText={` ${addMemeber.member_title_error === true ? "Please enter Name!" : ""}`}
                                    />
                                    <div className="charcter-sec">
                                      {addMemeber.member_title_maxlenth -
                                        addMemeber.member_title.length ===
                                      0 ? (
                                        <>
                                          <span
                                            className="char-limit"
                                            style={{ color: "#FF0000" }}
                                          >
                                            Max Character Limit reached{" "}
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <p className="max-charact-sec">
                                            Max Characters:&nbsp;
                                            {addMemeber.member_title_maxlenth -
                                              addMemeber.member_title.length}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  </Box>
                                </div>

                                <div
                                  className="form-secs inner-form-secs vali-forms"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="member_qualification"
                                      label="Designation"
                                      variant="standard"
                                      onChange={addMemeberInfo}
                                      name="member_qualification"
                                      value={addMemeber.member_qualification}
                                      error={
                                        addMemeber.member_qualification_error
                                      }
                                      helperText={` ${addMemeber.member_qualification_error === true ? "Please enter Designation!" : ""}`}
                                    />
                                    <div className="charcter-sec">
                                      {addMemeber.member_qualification_maxlenth -
                                        addMemeber.member_qualification
                                          .length ===
                                      0 ? (
                                        <>
                                          <span
                                            className="char-limit"
                                            style={{ color: "#FF0000" }}
                                          >
                                            Max Character Limit reached{" "}
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <p className="max-charact-sec">
                                            Max Characters:&nbsp;
                                            {addMemeber.member_qualification_maxlenth -
                                              addMemeber.member_qualification
                                                .length}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  </Box>
                                </div>

                                <div
                                  className="form-secs  form-secs-textarea  inner-form-secs vali-forms"
                                  style={{ marginBottom: "0px" }}
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& .MuiTextField-root": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="member_des"
                                      label="Short Description"
                                      placeholder="Short Description"
                                      multiline
                                      rows={2}
                                      variant="standard"
                                      onChange={addMemeberInfo}
                                      name="member_des"
                                      value={addMemeber.member_des}
                                      error={addMemeber.member_des_error}
                                      helperText={` ${addMemeber.member_des_error === true ? "Please enter Short Description!" : ""}`}
                                    />
                                    <div
                                      className="charcter-sec"
                                      style={{ marginTop: "7px" }}
                                    >
                                      {addMemeber.member_des_maxlenth -
                                        addMemeber.member_des.length ===
                                      0 ? (
                                        <>
                                          <span
                                            className="char-limit"
                                            style={{ color: "#FF0000" }}
                                          >
                                            Max Character Limit reached{" "}
                                          </span>
                                        </>
                                      ) : (
                                        <>
                                          <p className="max-charact-sec max-para">
                                            Max Characters:&nbsp;
                                            {addMemeber.member_des_maxlenth -
                                              addMemeber.member_des.length}
                                          </p>
                                        </>
                                      )}
                                    </div>
                                  </Box>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <div
                              className="button-sec update-mrn"
                              style={{ marginTop: "5px" }}
                            >
                              <button
                                type="button"
                                className="btn btn-login btn-update"
                                onClick={(e) => {
                                  submitLocationMember();
                                  e.preventDefault();
                                }}
                              >
                                {" "}
                                {addMemeber.member_id !== 0 ? "Update" : "Save"}
                                {loader === true ? (
                                  <CircularProgress
                                    style={{
                                      width: "15px",
                                      height: "15px",
                                      marginLeft: "5px",
                                      color: "white",
                                    }}
                                  />
                                ) : (
                                  ""
                                )}
                              </button>
                              <button
                                type="button"
                                className="btn btn-login btn-reset"
                                onClick={(e) => {
                                  resetdoc();
                                  e.preventDefault();
                                }}
                              >
                                Reset
                              </button>
                              <div className="validate-sec">
                                {successMsg !== "" ? (
                                  <div className="">
                                    <p className="succ-msg">{successMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="succ-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Member Addedd Successfully!
                                    </p>
                                  </div>
                                )}
                                {errorMsg !== "" ? (
                                  <div className="">
                                    <p className="error-msg">{errorMsg}</p>
                                  </div>
                                ) : (
                                  <div className="">
                                    <p
                                      className="error-msg"
                                      style={{ visibility: "hidden" }}
                                    >
                                      Something went wrong,please try again!
                                    </p>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel value="4">
                      <div className="table-sec-main">
                        <div className="top-table-sec">
                          <div className="row">
                            <div className="col-md-2 entries-padd">
                              <div className="sota-table-inner">
                                <p>Show Entries</p>
                                <select
                                  className="selectsec"
                                  onChange={perPageChange}
                                  value={perPage}
                                >
                                  <option value={10}>10</option>
                                  <option value={25}>25</option>
                                  <option value={50}>50</option>
                                  <option value={100}>100</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-md-7">
                              <div className="total-count">
                                {memeberList.length > 0 ? (
                                  <p>
                                    Total Members{" "}
                                    <span className="number-count">
                                      {totalCount}
                                    </span>
                                  </p>
                                ) : null}
                              </div>
                              <div className="tab-manage-sec clear-sec">
                                <button
                                  className=""
                                  onClick={(e) => clearfilter()}
                                >
                                  Clear Filter
                                </button>
                              </div>
                            </div>
                            <div className="col-md-3">
                              <div className="filter-sec">
                                <div
                                  className="form-secs filter-form-sec"
                                  id="member_title"
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="standard-basic"
                                      label="Name"
                                      variant="standard"
                                      value={searchText}
                                      name="member_title"
                                      onChange={doSearch}
                                    />
                                    <EastIcon onClick={(e) => gosubmit()} />
                                  </Box>
                                </div>

                                <div
                                  className="form-secs filter-form-sec"
                                  id="member_qualification"
                                  style={{ display: "none" }}
                                >
                                  <Box
                                    component="form"
                                    sx={{
                                      "& > :not(style)": {
                                        m: 1,
                                        width: "25ch",
                                      },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                  >
                                    <TextField
                                      id="standard-basic"
                                      label="Designation"
                                      variant="standard"
                                      value={searchText}
                                      name="member_qualification"
                                      onChange={doSearch}
                                    />
                                    <EastIcon onClick={(e) => gosubmit()} />
                                  </Box>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="form-table-sec">
                            <div className="row">
                              <div className="col-md-12 padding-no">
                                <table
                                  className="table table-bordered"
                                  style={{ marginTop: "0px" }}
                                >
                                  <thead>
                                    <tr className="tab-head-sec">
                                      <th className="admin-sl  serial-sec">
                                        Sl No
                                      </th>
                                      <th
                                        className="label-sec member-name hight-name"
                                        onClick={(e) =>
                                          checkfilsiw("member_title")
                                        }
                                      >
                                        Name
                                        <span
                                          className="top-sort "
                                          id="member_titledesc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-up"
                                            onClick={(e) =>
                                              checksortall(
                                                "member_title",
                                                "desc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                        <span
                                          className="bottom-sort  sortopacity"
                                          id="member_titleasc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-down"
                                            onClick={(e) =>
                                              checksortall(
                                                "member_title",
                                                "asc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </th>
                                      <th
                                        className="tit-sec memeber-des hight-des"
                                        onClick={(e) =>
                                          checkfilsiw("member_qualification")
                                        }
                                      >
                                        Designation
                                        <span
                                          className="top-sort "
                                          id="member_qualificationdesc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-up"
                                            onClick={(e) =>
                                              checksortall(
                                                "member_qualification",
                                                "desc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                        <span
                                          className="bottom-sort  sortopacity"
                                          id="member_qualificationasc"
                                        >
                                          <i
                                            className="fa-solid fa-sort-down"
                                            onClick={(e) =>
                                              checksortall(
                                                "member_qualification",
                                                "asc",
                                              )
                                            }
                                          ></i>
                                        </span>
                                      </th>
                                      <th className="para-sec memb-para hight-para">
                                        Short Description
                                      </th>
                                      <th className="director-img-sec">
                                        Image
                                      </th>

                                      <th className="adm-action">Status</th>
                                      <th className="action-sec">Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {firstLoading ? (
                                      <tr className="td-sec">
                                        <td colSpan={7}>
                                          <div
                                            className="spinner-border"
                                            role="status"
                                            style={{
                                              width: "1rem",
                                              height: "1rem",
                                              marginLeft: "6px",
                                            }}
                                          ></div>
                                        </td>
                                      </tr>
                                    ) : (
                                      <>
                                        {memeberList.length > 0 ? (
                                          memeberList.map((userd, index) => (
                                            <tr
                                              key={index}
                                              className="tab-data-sec"
                                            >
                                              <td className="tab-border-left">
                                                {pageNo * perPage -
                                                  perPage +
                                                  1 +
                                                  index}
                                              </td>
                                              <td>{userd.member_title}</td>
                                              <td>
                                                {userd.member_qualification}
                                              </td>
                                              <td>{userd.member_des}</td>
                                              <td className="desk-img-data">
                                                {userd.member_image !== "" &&
                                                  userd.member_image !=
                                                    null && (
                                                    <img
                                                      src={pathJoinUrl(
                                                        storage[0].imageEndUrl,
                                                        userd.member_image,
                                                      )}
                                                      alt="[]"
                                                    />
                                                  )}
                                              </td>

                                              <td className="toggle-sec">
                                                {loaderId ===
                                                userd.member_id ? (
                                                  <div
                                                    className="spinner-border"
                                                    role="status"
                                                    style={{
                                                      width: "1rem",
                                                      height: "1rem",
                                                      marginLeft: "6px",
                                                    }}
                                                  ></div>
                                                ) : userd.member_status ===
                                                  "active" ? (
                                                  <FormGroup>
                                                    <FormControlLabel
                                                      control={
                                                        <IOSSwitch
                                                          sx={{ m: 1 }}
                                                          onClick={(e) =>
                                                            toggleOff(
                                                              userd.member_id,
                                                            )
                                                          }
                                                          defaultChecked={
                                                            userd.member_status ===
                                                            "active"
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                      }
                                                    />
                                                  </FormGroup>
                                                ) : (
                                                  <FormGroup>
                                                    <FormControlLabel
                                                      control={
                                                        <IOSSwitch
                                                          sx={{ m: 1 }}
                                                          onClick={(e) =>
                                                            toggleOn(
                                                              userd.member_id,
                                                            )
                                                          }
                                                          defaultChecked={
                                                            userd.member_status ===
                                                            "active"
                                                              ? true
                                                              : false
                                                          }
                                                        />
                                                      }
                                                    />
                                                  </FormGroup>
                                                )}
                                              </td>
                                              <td className="edit-sec">
                                                <EditIcon
                                                  onClick={(e) =>
                                                    editLocation(e, userd)
                                                  }
                                                />
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={7}>No Data Found</td>
                                          </tr>
                                        )}
                                      </>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>

                          {/* pagination start */}
                          {totalPage > 1 ? (
                            <>
                              {pageLoader ? (
                                <div
                                  className="spinner-border"
                                  role="status"
                                  style={{
                                    width: "1rem",
                                    height: "1rem",
                                    marginLeft: "6px",
                                    float: "right",
                                    position: "absolute",
                                    bottom: "73px",
                                    right: "35px",
                                  }}
                                ></div>
                              ) : (
                                ""
                              )}

                              <div
                                className="pagination-sec"
                                style={{
                                  boxShadow: "#e29a1217 0px 7px 16px 0px",
                                  width: "auto",
                                  float: "right",
                                  border: "1px solid #0cb8b6",
                                  marginTop: "2px",
                                  marginRight: "20px",
                                  height: "40px",
                                }}
                              >
                                <div
                                  style={{
                                    float: "left",
                                    padding: "0px",
                                    color: "rgb(11, 92, 171)",
                                    fontSize: "14px",
                                    width: "100%",
                                    position: "relative",
                                    display: "inline-flex",
                                  }}
                                >
                                  <div className="pagin-sec">
                                    <i
                                      className="fa-solid fa-angle-left"
                                      onClick={(e) => changePage(pageNo - 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginLeft: "9px",
                                        marginRight: "10px",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "1px",
                                        marginRight: "1px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      Go to{" "}
                                    </span>
                                    <input
                                      className="number-secs"
                                      type="number"
                                      value={pageNo}
                                      onChange={(e) => {
                                        !isNaN(parseInt(e.target.value)) &&
                                        parseInt(e.target.value) > 0
                                          ? changePage(parseInt(e.target.value))
                                          : changePage(1);
                                      }}
                                      style={{
                                        color: "rgb(0, 23, 55)",
                                        margin: "9px 6px 0px 4px",
                                        fontSize: "14px",
                                        width: "34px",
                                        height: "22px",
                                        float: "left",
                                        textAlign: "center",
                                        border: "1px solid rgb(114, 114, 114)",
                                        borderRadius: "3px",
                                        outline: "none",
                                      }}
                                    />
                                    <span
                                      className="go-sec"
                                      style={{
                                        float: "left",
                                        fontSize: "15px",
                                        marginTop: "9px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        color: "rgb(114, 114, 114)",
                                      }}
                                    >
                                      of {totalPage}{" "}
                                    </span>
                                    <i
                                      className="fa-solid fa-angle-right"
                                      onClick={(e) => changePage(pageNo + 1)}
                                      style={{
                                        float: "left",
                                        marginTop: "10px",
                                        marginRight: "6px",
                                        marginLeft: "5px",
                                        cursor: "pointer",
                                        fontSize: "20px",
                                        color: "#E29A12",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : (
                            ""
                          )}

                          {/* pagination end */}
                        </div>
                      </div>
                    </TabPanel>
                  </TabContext>
                </Box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Memberhighlight;
